var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { TimeUnit } from '@feb-team/data-logic';
import TimerService from './TimerService';
import { formatTimeStr } from './timeUnits';
import { defaultProps } from './defaults';
import { SpanTag } from '../../Utils/AtomicTag';
var Countdown = /** @class */ (function (_super) {
    __extends(Countdown, _super);
    function Countdown(props) {
        var _this = _super.call(this, props) || this;
        _this.start = function () {
            TimerService.register(_this.countDown);
        };
        _this.stop = function () {
            TimerService.unregister(_this.countDown);
        };
        _this.done = function () {
            var onEnd = _this.props.onEnd;
            onEnd();
        };
        _this.pause = function () {
            _this.props.onPaused(_this.state.seconds);
            _this.stop();
        };
        _this.reStart = function () {
            _this.props.onRestart(_this.state.seconds);
            _this.start();
        };
        _this.countDown = function () {
            var seconds = _this.state.seconds - TimeUnit.Second;
            _this.setState({
                seconds: seconds,
            }, function () {
                _this.props.onChange(seconds);
            });
            if (seconds <= 0) {
                TimerService.unregister(_this.countDown);
                _this.done();
            }
        };
        var value = props.seconds, endDate = props.endDate, startDate = props.startDate;
        var seconds = 0;
        if (value) {
            seconds = value * TimeUnit.Second;
        }
        else if (endDate) {
            try {
                var currTime = startDate ? new Date(startDate).getTime() : new Date().getTime();
                var endTime = new Date(endDate).getTime();
                seconds = Math.max(endTime - currTime, 0);
            }
            catch (e) {
                console.warn(e);
            }
        }
        else {
            console.warn('请设置需倒计时时间');
        }
        _this.state = {
            seconds: seconds,
        };
        return _this;
    }
    Countdown.prototype.componentWillReceiveProps = function (nextProps) {
        var value = nextProps.seconds, endDate = nextProps.endDate, paused = nextProps.paused, startDate = nextProps.startDate;
        var seconds = this.state.seconds;
        if (value !== this.props.seconds ||
            endDate !== this.props.endDate ||
            startDate !== this.props.startDate) {
            if (value) {
                seconds = value * TimeUnit.Second;
            }
            else if (endDate) {
                try {
                    var currTime = startDate ? new Date(startDate).getTime() : new Date().getTime();
                    var endTime = new Date(endDate).getTime();
                    seconds = Math.max(endTime - currTime, 0);
                }
                catch (e) {
                    console.warn(e);
                }
            }
            this.setState({
                seconds: seconds,
            });
        }
        if (paused !== this.props.paused) {
            paused ? this.pause() : this.reStart();
        }
    };
    Countdown.prototype.componentDidMount = function () {
        if (!this.props.paused) {
            this.start();
        }
    };
    Countdown.prototype.componentWillUnmount = function () {
        TimerService.unregister(this.countDown);
    };
    Countdown.prototype.render = function () {
        var _a = this.props, children = _a.children, value = _a.seconds, onEnd = _a.onEnd, endText = _a.endText, endDate = _a.endDate, startDate = _a.startDate, format = _a.format, paused = _a.paused, onChange = _a.onChange, onPaused = _a.onPaused, onRestart = _a.onRestart, rest = __rest(_a, ["children", "seconds", "onEnd", "endText", "endDate", "startDate", "format", "paused", "onChange", "onPaused", "onRestart"]);
        var seconds = this.state.seconds;
        var isOver = seconds <= 0;
        var formatObj = formatTimeStr(seconds, format);
        var formatStr = !isOver ? formatObj.formatStr : endText;
        if (typeof children === 'function') {
            return (React.createElement(SpanTag, __assign({ name: Countdown.NAME }, rest), children(formatStr, formatObj.formatTime)));
        }
        return (React.createElement(SpanTag, __assign({ name: Countdown.NAME }, rest), formatStr));
    };
    Countdown.defaultProps = defaultProps;
    Countdown.NAME = 'countdown';
    Countdown.displayName = 'Countdown';
    return Countdown;
}(PureComponent));
export { Countdown };
